export const setupFiltros = () => {
  if (document.body.classList.contains("consultorios")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".consultorios__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("proveedores")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("trabajos")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("ortopedias")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("laboratorios")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("os-prepagas")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("farmacias")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("kinesiologias")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("especialidades")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }

  if (document.body.classList.contains("category-congresos")) {
    const filtrosTitulo = document.querySelector(
      ".bloque_apertura_seccion__titulo"
    );
    const filtrosForm = document.querySelector(
      ".bloque_apertura__columna--izq"
    );

    const sugerirEventoBtn = document.querySelectorAll(".sugerir__evento__btn");

    const sugerenciaForm = document.querySelector(
      ".contenedor__form__sugererir_evento"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }

    sugerirEventoBtn.forEach((btn) =>
      btn.addEventListener("click", () =>
        sugerenciaForm.scrollIntoView({ behavior: "smooth" })
      )
    );

    //Select fechas
    const choicesFecha = new Choices("#select-fecha", {
      removeItemButton: true,
      shouldSort: false,
      classNames: {
        containerInner: ["buscador__clinicas__select"],
      },
      itemSelectText: "",
      noResultsText: "No se encontraron resultados",
      noChoicesText: "No hay opciones disponibles",
      closeDropdownOnSelect: true,
    });

    choicesFecha.setChoices(
      [
        { value: "may-2025", label: "Mayo 2025" },
        { value: "jun-2025", label: "Junio 2025" },
        { value: "jul-2025", label: "Julio 2025" },
        { value: "ago-2025", label: "Agosto 2025" },
        { value: "sep-2025", label: "Septiembre 2025" },
      ],
      "value",
      "label",
      true
    );

    //Select precios

    const choicesPrecios = new Choices("#select-precio", {
      removeItemButton: true,
      shouldSort: false,
      classNames: {
        containerInner: ["buscador__clinicas__select"],
      },
      itemSelectText: "",
      noResultsText: "No se encontraron resultados",
      noChoicesText: "No hay opciones disponibles",
      closeDropdownOnSelect: true,
    });

    choicesPrecios.setChoices(
      [
        { value: "max-10000", label: "Hasta $10.000" },
        { value: "15000-30000", label: "$15.000 - $30.000" },
        { value: "min-30000", label: "Más de $30.000" },
      ],
      "value",
      "label",
      true
    );

    //select ubicacion
    const choicesUbicaciones = new Choices("#select-ubicacion", {
      removeItemButton: true,
      shouldSort: false,
      classNames: {
        containerInner: ["buscador__clinicas__select"],
      },
      itemSelectText: "",
      noResultsText: "No se encontraron resultados",
      noChoicesText: "No hay opciones disponibles",
      closeDropdownOnSelect: true,
    });

    choicesUbicaciones.setChoices(
      [
        { value: "mardel", label: "Mar del Plata" },
        { value: "caba", label: "CABA" },
        { value: "gba", label: "GBA" },
      ],
      "value",
      "label",
      true
    );

    //Select tipo de evento
    const choicesTipo = new Choices("#select-tipo", {
      removeItemButton: true,
      shouldSort: false,
      classNames: {
        containerInner: ["buscador__clinicas__select"],
      },
      itemSelectText: "",
      noResultsText: "No se encontraron resultados",
      noChoicesText: "No hay opciones disponibles",
      closeDropdownOnSelect: true,
    });

    choicesTipo.setChoices(
      [
        { value: "tipo1", label: "Tipo 1" },
        { value: "tipo2", label: "Tipo 2" },
        { value: "tipo3", label: "Tipo 3" },
      ],
      "value",
      "label",
      true
    );
  }

  if (document.body.classList.contains("medicos")) {
    const filtrosTitulo = document.querySelector(
      ".contenedor_bloque__titulo.filtros_mobile"
    );
    const filtrosForm = document.querySelector(
      ".template_listado__contenedor--col_izq"
    );

    if (window.visualViewport.width < 970) {
      filtrosTitulo.addEventListener("click", () =>
        filtrosForm.classList.toggle("filtros__activos")
      );
    }
  }
};
